import { EquipoAdicionalInstallTectAsig, EquiposUtilizadosInstallOTTecAsig, MaterialesUtilizadosInstallOTTecAsig } from '../equipos';
import { IOrdenServicioCorporativo } from '@/shared/interfaces/erp/orden_servicio_corporativo';


export type OTMaterialesInstallTecnicoCorporativoFormTabProps = {
  //form: UseFormReturn<SaveFormDataInstallTecAsig, any>;
  form: any;
  ordenTrabajo: IOrdenServicioCorporativo;
};

const OTMaterialesInstallTecnicoCorporativoFormTab: React.FC<
  OTMaterialesInstallTecnicoCorporativoFormTabProps
> = ({ ordenTrabajo, form }) => {
  ///* hooks -------------------
  // useEquiposDisponiblesFlotaOT({ ordenTrabajo: ordentrabajo! });

  return (
    <>

      {/* =============== EQUIPOS UTILIZADOS =============== */}
      <EquiposUtilizadosInstallOTTecAsig />

      {/* =============== MATERIALES UTILIZADOS =============== */}
      <MaterialesUtilizadosInstallOTTecAsig form={form} />

      {/* =============== EQUIPO ADICIONAL =============== */}
      <EquipoAdicionalInstallTectAsig ordenTrabajo={ordenTrabajo!} />
    </>
  );
};

export default OTMaterialesInstallTecnicoCorporativoFormTab;
